import { ScreenProtocolMessage } from "../../../ScreenProtocol";
import { SpinAndHoldSession } from "./SpinAndHoldSession";

export namespace SpinAndHoldMessages {
	
	export class SpinMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "spin";
		public session: SpinAndHoldSession = null;

		constructor(session: SpinAndHoldSession) {
			super(SpinMessage.msgname);
			this.session = session;
		}
	}

	export class PlusMessage extends ScreenProtocolMessage
	{
		public static readonly msgname = "plus";
		public session: SpinAndHoldSession = null;

		constructor(session: SpinAndHoldSession) {
			super(PlusMessage.msgname);
			this.session = session;
		}
	}

	export class WinValue extends ScreenProtocolMessage
	{
		public static readonly msgname = "winvalue";
		public win: number = null;

		constructor(win: number) {
			super(WinValue.msgname);
			this.win = win;
		}
	}

	
	export class StartShowWin2Screen extends ScreenProtocolMessage
	{
		public static readonly msgname = "startwin";
		
		constructor() {
			super(StartShowWin2Screen.msgname);
			
		}
	}


	export class ResetShowWin2Screen extends ScreenProtocolMessage
	{
		public static readonly msgname = "resetstate";
		
		constructor() {
			super(ResetShowWin2Screen.msgname);
			
		}
	}


	export class StartBounceFinalBonus extends ScreenProtocolMessage
	{
		public static readonly msgname = "StartBounce";
		
		constructor() {
			super(StartBounceFinalBonus.msgname);
			
		}
	}

	export class StopBounceFinalBonus extends ScreenProtocolMessage
	{
		public static readonly msgname = "StopBounce";
		
		constructor() {
			super(StopBounceFinalBonus.msgname);
			
		}
	}

}